import { type SelectDataObject } from '../_tools/inputfields/Select';

const sExtColors: SelectDataObject[] = [
    { i: 0, t: '(unbekannt)' },
    { i: 1, t: 'Beige' },
    { i: 2, t: 'Blau' },
    { i: 3, t: 'Braun' },
    { i: 4, t: 'Bronze' },
    { i: 5, t: 'Gelb' },
    { i: 6, t: 'Gold' },
    { i: 7, t: 'Grau' },
    { i: 8, t: 'Grün' },
    { i: 9, t: 'Orange' },
    { i: 10, t: 'Rot' },
    { i: 11, t: 'Schwarz' },
    { i: 12, t: 'Silber' },
    { i: 13, t: 'Violett' },
    { i: 14, t: 'Weiß' },
    { i: 15, t: 'Sonderfarbe' },
];
export default sExtColors;
